import { Col, Dropdown, Row, Space } from 'antd'
import { PermissionEditorButtonsProps } from './types'
import {
  BasicPermissionItem,
  CIMSModule,
  RoleTemplate,
  RoleTemplateItem,
} from '@cims-online/shared'
import CIMSTooltip from 'components/CIMSTooltip'
import { ItemType } from 'antd/lib/menu/hooks/useItems'
import CIMSButton from 'components/CIMSButton'
import { HelpMessage } from 'utils/constants'
import { ParseDisabledOptions } from 'utils/parseDisabled'
const {
  ClearPermissions,
  ClearPermissionsDisabled,
  ClearAdditionalPermissionsDisabled,
} = HelpMessage.Administration.Components

const PermissionEditorButtons: React.VFC<PermissionEditorButtonsProps> = ({
  disabled = false,
  roles,
  rolePermissions,
  checked,
  setChecked,
  _setChecked,
  openPanels,
  setOpenPanels,
}) => {
  const editorDisabledOptions: ParseDisabledOptions = {
    disabled,
    reason: {
      why: 'disabled',
      message: 'Permission Editor is disabled',
    },
  }
  return (
    <Row justify="space-between" align="bottom" style={{ marginBottom: 10 }}>
      <Col>
        {/**
         * Ant Design's Dropdown does not forward the `disabled` prop correctly to
         * its children, so we're compensating for that with this lovely ternary
         */}
        {disabled ? (
          <CIMSButton
            tooltip={{ placement: 'left' }}
            disabled={editorDisabledOptions}
          >
            Templates
          </CIMSButton>
        ) : (
          <Dropdown
            trigger={['click']}
            menu={{
              onClick: ({ key }) =>
                setChecked(
                  true,
                  RoleTemplate.findOrFail(({ id }) => id === key)
                    .permissionItems as BasicPermissionItem[]
                ),
              items: CIMSModule.reduce((items, module) => {
                const moduleTemplates: RoleTemplateItem[] =
                  RoleTemplate.findByModule(module)
                if (!!moduleTemplates.length)
                  items.push({
                    key: module.id,
                    label: module.name,
                    children: moduleTemplates.map(
                      ({ id, name, description }) => ({
                        key: id,
                        label: (
                          <CIMSTooltip title={description} placement="right">
                            {name}
                          </CIMSTooltip>
                        ),
                      })
                    ),
                  })
                return items
              }, new Array<ItemType>()),
            }}
          >
            <CIMSButton
              tooltip={{
                placement: 'left',
                title: HelpMessage.Administration.Components.Templates,
              }}
            >
              Templates
            </CIMSButton>
          </Dropdown>
        )}
      </Col>
      <Col>
        <Space>
          {!!openPanels.length && (
            <CIMSButton onClick={() => setOpenPanels([])}>
              Collapse All
            </CIMSButton>
          )}
          {roles ? (
            <CIMSButton
              tooltip={{
                title: ClearPermissions,
                placement: 'right',
              }}
              disabled={
                disabled
                  ? editorDisabledOptions
                  : {
                      disabled: !checked.filter(
                        (permissionId) =>
                          !rolePermissions.includes(permissionId)
                      ).length,
                      reason: {
                        why: 'disabled',
                        message: ClearAdditionalPermissionsDisabled,
                      },
                    }
              }
              onClick={() =>
                _setChecked((prevChecked) =>
                  prevChecked.filter((permissionId) =>
                    rolePermissions.includes(permissionId)
                  )
                )
              }
            >
              Clear Additional Permissions
            </CIMSButton>
          ) : (
            <CIMSButton
              disabled={
                disabled
                  ? editorDisabledOptions
                  : {
                      disabled: !checked.length,
                      reason: {
                        why: 'disabled',
                        message: ClearPermissionsDisabled,
                      },
                    }
              }
              onClick={() => _setChecked([])}
            >
              Clear Permissions
            </CIMSButton>
          )}
        </Space>
      </Col>
    </Row>
  )
}

export default PermissionEditorButtons
